import { useContext } from "react";
import { UserManagementContext } from "./UserManagement.context.tsx";

export const useUserManagement = () => {
  const context = useContext(UserManagementContext);

  if (!context) {
    throw new Error(
      "useUserManagement() must be used within UserManagementProvider",
    );
  }

  return context;
};
